import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-main-file-size.ejs';
import TextUtil from 'util/TextUtil.js';
import util         from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';


class MainFileSizeView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'keydown input[name="fileSize"]': 'validatePositiveNumeric'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }
        this.setFileSize();

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumericNotPeriod(ev);
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    setFileSize() {
        let sizeBytes = this.columnModel.get('maxSize');
        let sizeMb = 2;
        if (sizeBytes && sizeBytes > 0) {
            sizeMb = (sizeBytes / 1024) / 1024;
        } else {
            this.columnModel.set('maxSize', 2097152, {silent:true});
        }

        this.columnModel.set('fileSize', sizeMb, {silent: true});
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.columnModel.attributes[propName];

        let sizeBytes = (propVal * 1024) * 1024;
        let oldSizeBytes = (oldPropVal * 1024) * 1024;

        this.columnModel.attributes[propName] = propVal;
        this.columnModel.set('maxSize', sizeBytes, {silent: true});

        undoService.add({
            undo: () => {
                this.columnModel.attributes[propName] = oldPropVal;
                this.columnModel.set('maxSize', oldSizeBytes, {silent: true});
                this.render();  
            },
            redo: () => {
                this.columnModel.attributes[propName] = propVal;
                this.columnModel.set('maxSize', sizeBytes, {silent: true});
                this.render();  
            }
        }, textConstants.UNDO_MOVE);
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainFileSizeView;
